import { render } from "./ResultPaging.vue?vue&type=template&id=b807af08"
import script from "./ResultPaging.vue?vue&type=script&lang=js"
export * from "./ResultPaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__